<template>
    <div class="trafficContainer">
        <img :src="imageArray[imageIndex]" alt="" class="stationImage">
        <el-tabs type="border-card" class="stationWeather" @tab-click="changeAnotherTabs">
            <el-tab-pane :label="item.stationName" v-for="item in railwayWeatherData" :key="item.stationName">
                <div class="currentWeather">
                    <div class="curItem" v-for="(curValue,curKey) in item.currentWeather" :key="curKey">
                    <div class="data">{{curValue}}</div>
                    <div class="text">{{curKey}}</div>
                    </div>
                </div>
            </el-tab-pane>
            <div class="echartsWeather" id="echartsWeather"></div>
        </el-tabs>        
    </div>

</template>

<script>
import { address } from '../../assets/js/railwayInfo'
import {setOptions} from '../../config/echarts/option/weatherECharts'
import {home} from '../../api/index'
import echarts from '../../config/echarts/index.js'
export default {
    data() {
        return {
            // 接口路径
            baseApi: '',

            // 各个交通枢纽的基本信息
            railwayInfo: address,

            // 各个交通枢纽的天气信息
            railwayWeatherData: [],

            // 图片url数组
            imageArray: [],

            // 当前图片的下标
            imageIndex: 0,
        }
    },
    methods: {
        async getRailwayWeather() {
            const obtRes = await home.getGZ_trafficSpotsWeather();
            // const {data: obtRes} = await this.$http.get(this.imgBoot+'/data/gzWeather/obtData.json');
            var windCont = ['北风', '东北风', '东风', '东南风', '南风', '西南风', '西风', '西北风', '北风'];
            for(let item of Object.values(this.railwayInfo)) {
                let tempObj = {};
                for(let key in obtRes.data) {
                    if(key == item[1]) {
                        // 使用经纬度构造api路径
                        let lon = Math.floor(Math.floor(item[3]/0.05) * 0.05 / 0.05) * 0.05;
                        let lat = Math.floor(Math.floor(item[4]/0.05) * 0.05 / 0.05) * 0.05;
                        var name = ('giftDaily'+lon.toFixed(2)+'_'+lat.toFixed(2)).replace(/\./g,"");
                        // const {data: giftDaily} = await this.$http.get(this.imgBoot + '/data/giftDailyCache/' + name +'.json');
                        const giftDaily = await home.getGiftDailyCache(name);
                        // x轴的文本的范围
                        var ddate = new Date();
                        var hour = ddate.getHours();
                        var ddhour = hour + 1;
                        var startIndex = 0, endIndex = 0;
                        if(hour < 7) {
                            startIndex = hour + 4;
                        }else if( hour > 7 && hour < 18) {
                            startIndex = hour - 8;
                        }else {
                            startIndex = hour -19;
                        }
                        endIndex  = startIndex + 24;
                        // 封装echarts所需要的数据
                        let optionData = {
                        tempGroup: [],
                        rainGroup: [],
                        windGroup: [],
                        xText: [],
                        };

                        for(let i = startIndex; i < endIndex; i++) {
                            optionData.tempGroup.push(giftDaily.gift_t[i]);
                            optionData.rainGroup.push(giftDaily.gift_rain[i]);
                            optionData.windGroup.push(giftDaily.gift_winds[i]);
                            if(ddhour == 24) {
                                ddhour = 0;
                            }
                            optionData.xText.push(ddhour + "时");
                            ddhour++;
                        }

                        let options = setOptions(optionData);
                        tempObj = {
                            stationName: item[0],
                            currentWeather: {
                                '温度': obtRes.data[key].temp + '℃',
                                '雨量': obtRes.data[key].hourrf + 'mm',
                                '相对湿度': obtRes.data[key].rh === -999.9 ? '--' : obtRes.data[key].rh + '%',
                                '风速': obtRes.data[key].wd2ds + 'm/s',
                                '风向': windCont[Math.floor((obtRes.data[key].wd2dd+ 22.5) / 45)],
                            },
                            options,
                        }
                        this.imageArray.push(this.baseApi + '/gzhuanti/images/cy2020/' + item[2]);
                        this.railwayWeatherData.push(tempObj);
                    }
                }
            }               
            let stationEcharts = echarts.init(document.getElementById('echartsWeather'), 'dark');
            stationEcharts.setOption(this.railwayWeatherData[0].options); 
        },

        changeAnotherTabs(el) {
            echarts.init(document.getElementById('echartsWeather')).dispose();
            let stationEcharts = echarts.init(document.getElementById('echartsWeather'), 'dark')
            stationEcharts.setOption(this.railwayWeatherData[el.index].options);
            this.imageIndex = el.index;
        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_BASE_API;
        this.getRailwayWeather();
    },
}
</script>

<style lang="less">
    // 四站一场
    .trafficContainer {
        display: flex;
        justify-content: space-between;
        .stationImage {
            width: 39%;
            margin-top: 20px;
        }
        .stationWeather {
            position: relative;
            width: 60%;
            height: 315px;
            background-color:#333333;
            margin-top: 19px;
            .currentWeather {
                position: relative;
                height: 100%;
                width: 100%;
                display: flex;
                justify-content: space-evenly;
                align-items: flex-start;
                .curItem {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    height: 70px;
                    width: 15%;
                    border: 1px solid #acb4bf;
                    // padding: 0 11px;
                    border-radius: 4px;
                    .data,
                    .text {
                    width: 100%;
                    color: #5f9dda;
                    font-size: 16px;
                    text-align: center;
                    box-sizing: border-box;
                    font-weight: bold;
                    }
                    .data {
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #acb4bf;
                    font-size: 16px;
                    background-color: #198EF8;
                    color: white;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                    }
                    .text {
                    height: 30px;
                    line-height: 30px;
                    color: black;
                    background-color: #FFD200;
                    border-bottom-left-radius: 4px;
                    border-bottom-right-radius: 4px;
                    }
                }
            }
            .el-tabs__nav {
                width: 100%;
                display: flex;
                .el-tabs__item {
                    flex: 1;
                    height: 37px;
                    padding: 0 !important;
                    line-height: 37px;
                    text-align: center;
                }
            }
            .echartsWeather {
                width: 460px;
                height: 180px;
                margin: 0 auto;
                margin-top: 10px;
            }
            .el-tabs--border-card {
                border: none;
            }
        }        
    }

    .el-tabs--border-card {
        border: none !important;
    }
</style>